export default {
  账号设置_th: '账号设置',
  退出登录: '退出登录',
  您好: '您好',
  注册: '注册',
  登录: '登录',
  退出: '退出',
  充值: '充值',
  管理账号: '管理账号',
  新手指引: '新手指引',
  App下载: 'APP下载',
  领券中心: '领券中心',
  我的企业: '我的企业',
  昨日阅览: '昨日阅览',
  人次: '人次',
  我的名片: '我的云展',
  云采购: '云采购',
  下载云展动力APP: '下载云展动力APP',
  数字孪生精准获客平台: '数字孪生精准获客平台',
  密码登录: '密码登录',
  验证码登录: '验证码登录',
  其他登录方式: '其他登录方式',
  请绑定手机号码: '请绑定手机号码',
  绑定手机: '绑定手机',
  已有账号: '已有账号',
  去登录: '去登录',
}
